import 'uni-pages';import 'uni-h5';import App from './App'
import store from './lib/store.js'
import './env.js' // base
import Vue from 'vue'
import './uni.promisify.adaptor'
// 引入全局uView
import uView from '@/uni_modules/uview-ui'

Vue.config.productionTip = false
Vue.use(uView)
App.mpType = 'app'
const app = new Vue({
	...App,
	store
})
app.$mount()